// Subscription status, not a leftover plan name, determines paid access.
const PAID_PLANS = new Set(["diy", "basic", "starter", "professional", "enterprise"]);
const ACTIVE_STATUSES = new Set(["active", "trialing"]);

export const hasSubscriberAccess = (user) => (
  ACTIVE_STATUSES.has(String(user?.subscription_status || "").toLowerCase()) &&
  PAID_PLANS.has(String(user?.plan_key || "").toLowerCase())
);